import { render, staticRenderFns } from "./customBoxBbs.vue?vue&type=template&id=23626678&scoped=true&"
import script from "./customBoxBbs.vue?vue&type=script&lang=js&"
export * from "./customBoxBbs.vue?vue&type=script&lang=js&"
import style0 from "./customBoxBbs.vue?vue&type=style&index=0&id=23626678&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23626678",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/merchant_5Yxh/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23626678')) {
      api.createRecord('23626678', component.options)
    } else {
      api.reload('23626678', component.options)
    }
    module.hot.accept("./customBoxBbs.vue?vue&type=template&id=23626678&scoped=true&", function () {
      api.rerender('23626678', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/customChildren/customBoxBbs.vue"
export default component.exports